import { useEffect, useState } from 'react';
import reportImg2223 from '../assets/images/reportsImg/reports2223.png';
import {
  fetchPublications,
  fetchInternalReports,
} from '../services/operations/publicationsAPI';

const annualReports = [
  {
    year: '2023-2024',
    link: '/annual-reports-pdf/NCMRWF_AnnualReport_2023-2024.pdf',
  },
  {
    year: '2022-2023',
    link: '/annual-reports-pdf/NCMRWF_Annual-Report_2022-2023.pdf',
  },
];

const ASSETS_BASE_URL = process.env.REACT_APP_ASSETS_BASE_URL;

const Publications = () => {
  const [activeTab, setActiveTab] = useState('Publications');
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedYear, setSelectedYear] = useState('2024');
  const [internalReports, setInternalReports] = useState(null);

  useEffect(() => {
    const getPublications = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchPublications(selectedYear);
        setPublications(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (selectedYear) {
      getPublications();
    }
  }, [selectedYear]);

  useEffect(() => {
    const getReports = async () => {
      if (activeTab !== 'Internal Reports') return;
      setLoading(true);
      setError(null);
      try {
        const data = await fetchInternalReports();
        setInternalReports(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getReports();
  }, [activeTab]);

  return (
    <div className="mx-auto max-w-6xl rounded-lg bg-white p-8 shadow-lg">
      <div className="mb-6 flex justify-center space-x-4">
        {['Publications', 'Internal Reports', 'Annual Reports'].map((tab) => (
          <button
            key={tab}
            className={`rounded-full px-6 py-2 text-lg font-semibold shadow-md transition-all duration-300 ${
              activeTab === tab
                ? 'scale-105 bg-blue-600 text-white'
                : 'bg-slate-200 hover:bg-slate-300'
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="rounded-lg border border-slate-300 bg-slate-50 p-6">
        {activeTab === 'Publications' && (
          <div>
            <h2 className="mb-4 border-b-2 border-blue-500 pb-2 text-2xl font-bold text-slate-800">
              Publications
            </h2>
            <div className="mb-4">
              <label className="mr-2 text-lg font-semibold text-slate-800">
                Select Year:
              </label>
              <select
                className="rounded border border-slate-300 px-3 py-2 text-lg"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                <option value="2024">2024</option>
                <option value="2023">2023</option>
              </select>
            </div>
            {loading && <p>Loading...</p>}
            {error && <p className="text-red-600">{error}</p>}
            {!loading && !error && publications.length === 0 && (
              <p>No publications found.</p>
            )}
            {!loading && !error && (
              <ul className="space-y-4">
                {publications.map((pub, index) => (
                  <li key={index} className="text-slate-700">
                    <strong className="text-slate-900">{pub.authors},</strong>{' '}
                    {pub.title}. <em>{pub.journal}</em>
                    {pub.doi && (
                      <>
                        {' '}
                        (DOI:{' '}
                        <a
                          href={`https://doi.org/${pub.doi}`}
                          className="text-blue-600 hover:underline"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {pub.doi}
                        </a>
                        )
                      </>
                    )}
                    .
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {activeTab === 'Annual Reports' && (
          <div>
            <h2 className="mb-4 border-b-2 border-blue-500 pb-2 text-2xl font-bold text-slate-800">
              Annual Reports
            </h2>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              {annualReports.map((report, index) => (
                <a
                  key={index}
                  href={`${ASSETS_BASE_URL}${report.link}`}
                  className="flex flex-col items-center rounded-lg bg-white p-4 shadow-md transition hover:shadow-lg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={reportImg2223}
                    alt="Annual Report"
                    className="h-32 w-auto rounded-lg shadow-md"
                  />
                  <span className="mt-3 text-lg font-semibold text-blue-600">
                    {report.year}
                  </span>
                </a>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'Internal Reports' && (
          <div>
            <h2 className="mb-4 border-b-2 border-blue-500 pb-2 text-2xl font-bold text-slate-800">
              Internal Reports
            </h2>
            <ul className="space-y-3">
              {internalReports && internalReports.length > 0 ? (
                internalReports.map((report, index) => (
                  <li key={index} className="flex items-center space-x-2">
                    <a
                      href={report.link}
                      className="text-blue-600 hover:underline"
                    >
                      {report.title}
                    </a>
                    {report.status === 'new' && (
                      <span className="ml-2 rounded-full bg-green-500 px-2 py-1 text-xs font-semibold text-white">
                        New
                      </span>
                    )}
                  </li>
                ))
              ) : (
                <p>No internal reports available.</p>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Publications;
